import {
    Button,
    Col,
    Row,
    Spinner
} from "reactstrap";
import React from "react";
import withNavigateHook from '../../hooks/withNavigationHook';
import Api from "../../components/helpers/Api";
import {RiUserVoiceLine} from "react-icons/ri";
import AutoCompleteInput from "../song/AutoCompleteInput";
import ChooseTemplateModal from "../../components/service-plan/ChooseTemplateModal";

class YourRecentPlaylists extends React.Component {
    state = {
        isLoading: false,
        recentPlaylists: [],
        showChooseTemplate: false
    }

    componentDidMount() {
        this.setState({isLoading: true});
        Api.get(`/user/` + JSON.parse(sessionStorage.getItem("customer")).user.id + `/curated-playlist?maxRows=5`)
            .then(res => {
                this.setState({recentPlaylists: res.data});
                this.setState({isLoading: false});
            });
    }

    displayPlaylists = () => {
        const output = this.state.recentPlaylists.map((p, index) => {
            return <div className="col-lg-12">
                <Row>
                    <Col>
                        <a href={'/playlist/' + p.id + '/' + p.name}><b>{p.name}</b></a> ({p.curatedSongCount})
                    </Col>
                </Row>
                <Row>
                    <Col style={{color:'lightgrey'}}>{new Date(p.lastUpdatedAt).toDateString()}</Col>
                </Row>
            </div>
        })

        return output;
    }

    renderScriptureChoosePassages = () => {
        return "/scripture/choose-passages";
    }

    renderThemesChoosePassages = () => {
        return "/themes/choose-themes";
    }

    createNewSongFlow = () => {
        if (sessionStorage.getItem("customer")) {
            this.setState({ showChooseTemplate: true });
            return;
        }
        sessionStorage.removeItem("playlist");
        sessionStorage.removeItem("curated-songs");
        this.props.navigation("/scripture/curated-songs")
    }

    handleTemplateApply = (template) => {
        sessionStorage.removeItem("playlist");
        sessionStorage.removeItem("curated-songs");
        if (template) {
            const timestamp = Date.now();
            const items = (template.items || [])
                .filter(item => item.itemType === 'SERVICE_PART' || !item.itemType || item.itemType !== 'SONG')
                .map((item, index) => ({
                    i: index,
                    playOrder: index,
                    key: 'service-part/' + timestamp + '-' + index,
                    itemType: 'SERVICE_PART',
                    servicePartTitle: item.servicePartTitle ?? item.title,
                    servicePartNotes: item.servicePartNotes ?? item.notes ?? ''
                }));
            if (items.length > 0) {
                sessionStorage.setItem("curated-songs", JSON.stringify(items));
            }
        }
        this.setState({ showChooseTemplate: false });
        this.props.navigation("/scripture/curated-songs");
    }

    handleTemplateClose = () => {
        sessionStorage.removeItem("playlist");
        sessionStorage.removeItem("curated-songs");
        this.setState({ showChooseTemplate: false });
        this.props.navigation("/scripture/curated-songs");
    }

    render() {
        return (
            <>
                {
                    this.state.isLoading ?
                        <div className="spinner-container">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden"></span>
                            </Spinner>
                            &nbsp;Loading...
                        </div>
                        :
                        <Row className="lg-12">
                            {
                                this.state.recentPlaylists.length === 0 &&
                                <>
                                    <p className="description mt-3">
                                        You haven't saved any song-flows yet.<br/>
                                        <br/>
                                        You can build, save and edit unlimited curated song-flows using all of our
                                        {" "}{!sessionStorage.getItem("statsTtl") || JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books").value === 0 ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books").value}{" "}
                                        song books.
                                    </p>
                                    <Row>&nbsp;</Row>
                                    <Row className="pl-4 col-md-12 col-sm-12 col-xs-12">
                                        <Col className="col-md-12 col-sm-12 col-xs-12">
                                            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase d-flex align-items-center">
                                                <div className="icon icon-shape icon-shape-primary rounded-circle">
                                                    <RiUserVoiceLine/>
                                                </div>
                                                <span className="ml-3">Start with a Song</span>
                                            </h2>
                                        </Col>
                                    </Row>
                                    <Row className="col-md-12 col-sm-12 col-xs-12">
                                        <Col className="col-md-12 col-sm-12 col-xs-12">
                                            <p className="description mt-3">
                                                <AutoCompleteInput navTo="/songs/search"/>
                                            </p>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row className="lg-12">
                                        <Col md="12">
                                            <Button
                                                block
                                                className="mb-3"
                                                color="primary"
                                                type="button"
                                                href={this.renderScriptureChoosePassages()}
                                            >
                                              <span className="btn-inner--icon mr-3">
                                                <i className="ni ni-book-bookmark"/>
                                              </span>
                                                Start with Scripture
                                            </Button>
                                        </Col>
                                        <Col md="12">
                                            <Button
                                                block
                                                className="mb-3"
                                                color="primary"
                                                type="button"
                                                href={this.renderThemesChoosePassages()}
                                            >
                                              <span className="btn-inner--icon mr-3">
                                                <i className="ni ni-archive-2"/>
                                              </span>
                                                Start with a Theme
                                            </Button>
                                        </Col>
                                        <Col md="12">
                                            <Button
                                                block
                                                className="mb-3"
                                                color="primary"
                                                type="button"
                                                href="/lectionary/choose-lectionary"
                                            >
                                              <span className="btn-inner--icon mr-3">
                                                <i className="ni ni-books" />
                                              </span>
                                                Start with a Lectionary
                                            </Button>
                                        </Col>
                                    </Row>
                                </>
                            }
                            {
                                this.state.recentPlaylists.length !== 0 &&
                                <>
                                    {this.displayPlaylists()}
                                    <Row>
                                        <Col className="col-md-12">
                                            <Button
                                                className="mt-4"
                                                color="primary"
                                                style={{ width: "100%" }}
                                                href="/your-profile/saved-song-flows"
                                            >
                                                View all saved song-flows
                                            </Button>
                                        </Col>
                                        <Col className="col-md-12">
                                            <Button
                                                className="my-4"
                                                color="primary"
                                                type="button"
                                                style={{ width: "100%" }}
                                                onClick={() => this.createNewSongFlow()}
                                            >
                                                <span aria-hidden={true}>Create a new song-flow</span>
                                            </Button>
                                        </Col>
                                    </Row>
                                </>
                            }
                        </Row>
                }
                <ChooseTemplateModal
                    isOpen={this.state.showChooseTemplate}
                    onClose={this.handleTemplateClose}
                    onApply={this.handleTemplateApply}
                />
            </>
        );
    }
}


export default withNavigateHook(YourRecentPlaylists);
